import { createFeatureSelector, createSelector } from '@ngrx/store'
import * as reducer from './api-keys.reducer'
import * as state from './api-keys.state'

export const apiKeyState = createFeatureSelector<state.State>('apiKey')

export const selectAllApiKeys = createSelector(apiKeyState, reducer.selectAll)

export const selectApiKeysLoaded = createSelector(apiKeyState, (state: state.State) => state.isLoaded)
